import SegmentSummary from './SegmentSummary';

export default SegmentSummary;
